import { render, staticRenderFns } from "./CategoriesCard.vue?vue&type=template&id=6cc9e181&"
import script from "./CategoriesCard.vue?vue&type=script&lang=js&"
export * from "./CategoriesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc9e181')) {
      api.createRecord('6cc9e181', component.options)
    } else {
      api.reload('6cc9e181', component.options)
    }
    module.hot.accept("./CategoriesCard.vue?vue&type=template&id=6cc9e181&", function () {
      api.rerender('6cc9e181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/Widgets/CategoriesCard.vue"
export default component.exports